module.exports = __webpack_public_path__ + "static/media/camera-icon.3c5e7333.svg";